window.cgrt_status_values = [
	'unmatched',
	'matched',
	'parked',
	'nomatch',
]

class CGRT_Project {
	constructor(data) {
		if (empty(data)) data = {}
		if (empty(data.file_ids)) data.file_ids = {}
		if (empty(data.status)) data.status = {}

		// project_id (GUID): set to a new value if empty
		if (!empty(data.project_id)) this.project_id = data.project_id
		else this.project_id = U.new_uuid()

		// basic data
		sdp(this, data, 'deleted', false)
		sdp(this, data, 'project_name', '')
		sdp(this, data, 'case_framework_title', '')
		sdp(this, data, 'case_framework_guid', '')
		sdp(this, data, 'case_framework_cached_at', 0)
		sdp(this, data, 'line_count_case', 0)
		sdp(this, data, 'db_filename', '')
		sdp(this, data, 'db_delimiter', 'comma')	// 'comma' or 'tab'
		sdp(this, data, 'db_uploaded_at', 0)
		sdp(this, data, 'line_count_db', 0)
		sdp(this, data, 'sim_scores_calculated_at', 0)
		sdp(this, data, 'sim_score_lines_processed', 0)
		sdp(this, data, 'use_grades_for_sim_scores', '')
		sdp(this, data, 'created_at', 0)
		sdp(this, data, 'updated_at', 0)
		sdp(this, data, 'nonce', '')

		// file IDs for...
		sdp(this, data, 'file_ids', {})
		// the cached CASE framework
		sdp(this.file_ids, data.file_ids, 'case_framework', '')
		// the uploaded DB export
		sdp(this.file_ids, data.file_ids, 'db_upload', '')
		// calculated similarity scores
		sdp(this.file_ids, data.file_ids, 'sim_scores', '')
		// current status of each row, as determined by the user using the tool
		sdp(this.file_ids, data.file_ids, 'status', '')

		// status summary data, for showing in the projects table
		sdp(this, data, 'status_summary', {})
		sdp(this.status_summary, data.status_summary, 'db_row_count', 0)
		for (let sv of window.cgrt_status_values) {
			// one status_summary count for each cgrt_status_value
			sdp(this.status_summary, data.status_summary, sv, 0)
		}
	}
}
window.CGRT_Project = CGRT_Project
